import { useMemo } from 'react';
import { State } from 'country-state-city';

export const useStateOptions = (selectedCountry: string) => {
  const states = useMemo(
    () => [
      {
        title: 'Choose state/province',
        value: '',
      },
      // all states in the correct format
      ...State.getStatesOfCountry(selectedCountry)
        // convert each state to { title, value } format for FormSelect
        .map(({ name, isoCode }) => ({ value: isoCode, title: name })),
    ],
    [selectedCountry],
  );

  return states;
};
